/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:29
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-16 14:40:05
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\recruit\mutations.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import * as STATETYPES from '../stateTypes'
const mutations = {
	[MUTATIONTYPES.SETRECRUITFORM](state, data) {
		state[STATETYPES.RECRUITFORM] = data
	}
}
export default mutations